var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStairsOutdoorFloor1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 223.84004,
    height: 115.20001,
    viewBox: "0 0 223.84003 115.20001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1008"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1008"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1010"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1010"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1012"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1012"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1014"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1014"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1016"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1016"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1018"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1018"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1020"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1020"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1022"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1022"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1024"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1024"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1026"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1026"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1028"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1028"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1030"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1030"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1032"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1032"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1034"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1034"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1036"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1036"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1038"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1038"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1040"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1040"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1042"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1042"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1044"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1044"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1046"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1046"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1048"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1048"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1050"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1050"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1052"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1052"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1054"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1054"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1073"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path1073"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1076"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1311,0 H 3413 V 6212 H 1311 V 0",
    transform: "rotate(90,2514.5,480)",
    id: "path1076"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer-oc1",
    transform: "translate(-376.10668,-418.02668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1005",
    d: "m 2183,4217 v -434 h -625 v 434 h 625",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1006",
    d: "m 1870,3783 v -789 h 16 v 789 h -16",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1007",
    d: "M 2039,2994 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1009",
    d: "m 2038,2994 h 1 z m 1,0 h -1 v 1 z m -1,0 v 1 1 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1010)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1011",
    d: "m 2038,2995 v -1 0 z m 0,-1 v 0 2 z m 0,0 v 2 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1013",
    d: "m 2038,2994 v 2 l -1,-2 z m 0,2 -1,-2 v 3 z m -1,-2 v 3 z m 0,3 v -3 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1014)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1015",
    d: "m 2037,2994 v 3 l -1,-3 z m 0,3 -1,-3 v 4 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1016)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1017",
    d: "m 2036,2994 v 4 l -1,-4 z m 0,4 -1,-4 v 4 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1019",
    d: "m 2035,2994 v 4 l -1,-4 z m 0,4 -1,-4 v 4 z m -1,-4 v 4 z m 0,4 v -4 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1020)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1021",
    d: "m 2034,2994 v 4 l -1,-4 z m 0,4 -1,-4 v 4 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1022)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1023",
    d: "m 2033,2994 v 4 l -1,-4 z m 0,4 -1,-4 v 3 z m -1,-4 v 3 z m 0,3 v -3 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1024)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1025",
    d: "m 2032,2994 v 3 l -1,-3 z m 0,3 -1,-3 v 2 z m -1,-3 v 2 z m 0,2 v -2 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1027",
    d: "m 2031,2994 v 2 l -1,-2 z m 0,2 -1,-2 v 1 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1028)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1029",
    d: "m 2030,2995 v -1 0 z m 0,-1 z m 0,0 v 0 1 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1030)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1031",
    d: "m 2039,2994 v -1 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1033",
    d: "m 2039,2993 v 1 l -1,-2 z m 0,1 -1,-2 v 2 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1034)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1035",
    d: "m 2038,2991 v 3 z m 0,3 v -3 0 z m 0,-3 v 0 3 z m 0,0 v 3 -2 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1037",
    d: "m 2038,2991 v 3 l -1,-4 z m 0,3 -1,-4 v 4 z m -1,-4 v 4 z m 0,4 v -4 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1038)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1039",
    d: "m 2037,2990 v 4 l -1,-4 z m 0,4 -1,-4 v 4 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1040)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1041",
    d: "m 2036,2990 v 4 l -1,-5 z m 0,4 -1,-5 v 5 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1043",
    d: "m 2035,2989 v 5 l -1,-5 z m 0,5 -1,-5 v 5 z m -1,-5 v 5 z m 0,5 v -5 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1044)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1045",
    d: "m 2034,2989 v 5 l -1,-4 z m 0,5 -1,-4 v 4 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1046)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1047",
    d: "m 2033,2990 v 4 l -1,-4 z m 0,4 -1,-4 v 4 z m -1,-4 v 4 z m 0,4 v -4 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1049",
    d: "m 2032,2990 v 4 l -1,-3 z m 0,4 -1,-3 v 3 z m -1,-3 v 3 z m 0,3 v -3 0 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1050)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1051",
    d: "m 2031,2991 v 3 l -1,-2 z m 0,3 -1,-2 v 2 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1053",
    d: "m 2030,2994 v -1 0 z m 0,-1 v 0 1 z m 0,0 v 1 -2 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1055",
    d: "m 1886,2994 v 79 h 297 v -79 h -297",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1056",
    d: "m 1886,3073 v 79 h 297 v -79 h -297",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1057",
    d: "m 1886,3152 v 78 h 297 v -78 h -297",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1058",
    d: "m 1886,3230 v 79 h 297 v -79 h -297",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1059",
    d: "m 1886,3309 v 79 h 297 v -79 h -297",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1060",
    d: "m 1886,3388 v 79 h 297 v -79 h -297",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1061",
    d: "m 1886,3467 v 79 h 297 v -79 h -297",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1062",
    d: "m 1886,3546 v 79 h 297 v -79 h -297",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1063",
    d: "m 1886,3625 v 79 h 297 v -79 h -297",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1064",
    d: "m 1886,3704 v 79 h 297 v -79 h -297",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1065",
    d: "m 1870,3783 v -789 h -16 v 789 h 16",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1066",
    d: "m 1854,3388 v 79 h -148 148 v 79 h -296",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1067",
    d: "m 1854,3546 v 79 h -296 v -79 h 296",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1068",
    d: "m 1854,3625 v 79 h -296 v -79 h 296",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1069",
    d: "m 1854,3704 v 79 h -296 v -79 h 296",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1070",
    d: "m 1854,3388 -296,158",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1071",
    d: "M 2034,2994 V 4017 H 1706",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1072",
    d: "m 1720,3499 -14,-32 v 21 z m -14,-32 v 21 l -15,11 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath1073)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1074",
    d: "M 1706,4017 V 3467",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1075",
    d: "M 4.5,0 C 4.5,2.48528 2.48528,4.5 0,4.5 -2.48528,4.5 -4.5,2.48528 -4.5,0 c 0,-2.48528 2.01472,-4.5 4.5,-4.5 2.48528,0 4.5,2.01472 4.5,4.5",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.16,0,0,-0.16,579.54667,449.14667)",
    clipPath: "url(#clipPath1076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1077",
    d: "m 1706,3488 -15,11 15,-32 14,32 -14,-11",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1111",
    d: "m 2183,4217 v 46 h 43 v -46 h -43",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1112",
    d: "m 1558,4217 v 46 h -45 v -46 h 45",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1113",
    d: "m 1558,2915 v -45 h -46 v 45 h 46",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1114",
    d: "m 2224,2915 v -45 h -45 v 45 h 45",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1115",
    d: "M 2183,4217 V 2915 h 19 v 1302 h -19",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1116",
    d: "M 1538,4217 V 2915 h 20 v 1302 h -20",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1117",
    d: "m 2183,4217 v 23 h -625 v -23 h 625",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStairsOutdoorFloor1);
export default __webpack_public_path__ + "static/media/stairs_outdoor_floor1.388f4bea1e213fb35add42e0af601c29.svg";
export { ForwardRef as ReactComponent };